export enum FormSubmissionType {
    EMERGE = 're2024-emerge',
    REPLUS_PLAN = 'replus-plan',
    MARKETING_CONTACT_FORM = 'marketing-contact-form',
    PPL_PRICE_CONFIGURATOR = 'ppl-price-configurator',
    DC_QUIZ_LEAD = 'dc-quiz-lead',
}
